var exports = {
  "kL": "xe7b6e3d6--1d5093--container",
  "Pf": "xe7b6e3d6--1d5093--label",
  "Uq": "xe7b6e3d6--1d5093--value",
};

module.exports = exports;
